module.exports = __webpack_public_path__ + "static/media/safe_1_알림톡입퇴실.b3d42d72.JPG";